import { until } from 'until-async'
import { getErrorLog } from '../../robowhale/utils/error/utils'
import { Platform } from '../Platform'
import { BasePlatformPreloader } from './BasePlatformPreloader'

type PlaygamaBridge = {
	initialize: () => Promise<unknown>
}

export class PlaygamaPlatformPreloader extends BasePlatformPreloader {
	public readonly type: Platform = 'playgama'
	private _initCompleted: Promise<unknown> | undefined

	public async loadAndInit(): Promise<unknown> {
		if (this._initCompleted) {
			return this._initCompleted
		}

		await this.loadBridgeScript()

		this._initCompleted = this.initBridge()

		return this._initCompleted
	}

	private async loadBridgeScript(): Promise<void> {
		const hasBridge = this.hasBridge()
		if (hasBridge) {
			return
		}

		await this.loadScriptWithRetries('https://bridge.playgama.com/v1/stable/playgama-bridge.js')
	}

	private async initBridge(): Promise<unknown> {
		const bridge = window['bridge'] as PlaygamaBridge | undefined
		if (!bridge?.initialize) {
			throw new Error('Playgama bridge is not available')
		}

		const [error, result] = await until(() => bridge.initialize())
		if (error) {
			throw new Error(getErrorLog(error))
		}

		return result ?? bridge
	}

	private hasBridge(): boolean {
		const bridge = window['bridge'] as PlaygamaBridge | undefined
		return Boolean(bridge?.initialize)
	}
}
